import { Box, Button, Container, Grid, Stack, Typography } from '@mui/joy';
import {
    Microphone,
    VideoCamera,
    PhoneDisconnect
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';

const CALL_BLOBS = [
    { color: 'rgba(255, 220, 0, 0.95)', size: '100%', x: '-20%', y: '40%' },
    { color: 'rgba(0, 180, 255, 0.95)', size: '90%', x: '50%', y: '-20%' },
    { color: 'rgba(50, 220, 100, 0.85)', size: '85%', x: '10%', y: '20%' },
    { color: 'rgba(255, 60, 180, 0.9)', size: '90%', x: '60%', y: '55%' },
    { color: 'rgba(130, 0, 255, 0.9)', size: '80%', x: '-15%', y: '-15%' },
    { color: 'rgba(255, 100, 0, 0.85)', size: '75%', x: '35%', y: '70%' },
    { color: 'rgba(0, 255, 200, 0.8)', size: '80%', x: '70%', y: '20%' },
    { color: 'rgba(255, 30, 60, 0.8)', size: '70%', x: '20%', y: '-15%' },
];

const CALL_BUTTONS = [
    { icon: <Microphone size={22} weight="fill" />, label: 'Микрофон' },
    { icon: <PhoneDisconnect size={26} weight="fill" />, label: 'Завершить', big: true },
    { icon: <VideoCamera size={22} weight="fill" />, label: 'Камера' },
];

function CallDemo() {
    return (
        <Box
            aria-hidden
            sx={{
                position: 'relative',
                width: '100%',
                aspectRatio: { xs: 'auto', md: '10/8' },
                minHeight: { xs: 440, md: 0 },
                borderRadius: '24px',
                overflow: 'hidden',
                bgcolor: '#4a0080',
                color: '#fff',
                userSelect: 'none',
                boxShadow: '0 20px 50px rgba(20, 130, 127, 0.18)',
            }}
        >
            <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
                {CALL_BLOBS.map((b, i) => (
                    <Box
                        key={i}
                        sx={{
                            position: 'absolute',
                            width: b.size,
                            aspectRatio: '1',
                            left: b.x,
                            top: b.y,
                            borderRadius: '50%',
                            background: `radial-gradient(circle, ${b.color} 0%, transparent 70%)`,
                            filter: 'blur(40px)',
                        }}
                    />
                ))}
                <Box sx={{ position: 'absolute', inset: 0, background: 'rgba(10, 8, 20, 0.15)' }} />
            </Box>

            <Stack alignItems="center" spacing={1.25} sx={{ position: 'absolute', inset: 0, justifyContent: 'center', zIndex: 2, px: 2 }}>
                <Box
                    sx={{
                        width: { xs: 88, md: 104 },
                        height: { xs: 88, md: 104 },
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(255,255,255,0.14)',
                        backdropFilter: 'blur(8px)',
                        boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
                    }}
                >
                    <img
                        src="/img/welcome/57.jpg"
                        alt="Изображение кота который звонит человеку"
                        style={{
                            maxWidth: '200px',
                            width: '100%',
                            height: 'auto',
                            borderRadius: '999px',
                        }}
                    />
                </Box>
                <Typography level="title-lg" sx={{ color: '#fff', fontWeight: 700 }}>Поля 💋</Typography>
                <Typography level="body-sm" sx={{ color: 'rgba(255,255,255,0.7)' }}>Звоним…</Typography>
            </Stack>

            <Box
                sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    zIndex: 3,
                    width: { xs: 84, md: 104 },
                    aspectRatio: '3 / 4',
                    borderRadius: '14px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255,255,255,0.12)',
                    backdropFilter: 'blur(8px)',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                }}
            >
                <img
                    src="/img/welcome/man.jpg"
                    alt="Мужчина разговаривает по видеосвязи"
                    style={{
                        width: '100%',
                        height: 'auto',
                    }}
                />
            </Box>

            <Stack
                direction="row"
                alignItems="flex-end"
                spacing={{ xs: 3, md: 4 }}
                sx={{ position: 'absolute', bottom: { xs: 18, md: 28 }, left: 0, right: 0, justifyContent: 'center', zIndex: 3 }}
            >
                {CALL_BUTTONS.map((b, i) => (
                    <Stack key={i} alignItems="center" spacing={0.75}>
                        <Box
                            sx={{
                                width: b.big ? 60 : 52,
                                height: b.big ? 60 : 52,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                backdropFilter: 'blur(20px)',
                                background: b.big
                                    ? 'linear-gradient(135deg, #ff3b3b, #c0001a)'
                                    : 'rgba(255,255,255,0.15)',
                                boxShadow: b.big
                                    ? '0 0 30px rgba(255,40,40,0.5), 0 4px 16px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.25)'
                                    : '0 4px 20px rgba(255,255,255,0.15), inset 0 1px 0 rgba(255,255,255,0.12)',
                            }}
                        >
                            {b.icon}
                        </Box>
                        <Typography level="body-xs" sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '10px', letterSpacing: '0.03em' }}>
                            {b.label}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
}

export function CallSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
                    <Grid xs={12} md={6}>
                        <FadeIn>
                            <Typography
                                level="h2"
                                sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 2 }}
                            >
                                Звонки работают{' '}
                                <Box component="br" sx={{ display: { xs: 'none', md: 'block' } }} />
                                прямо из чата
                            </Typography>
                            <Typography level="body-lg" sx={{ color: 'text.secondary', mb: 3 }}>
                                Аудио- и видеозвонки одним касанием, стабильно и без
                                ограничений. Поговорите с близкими там, где вам удобно.
                            </Typography>
                            <Button
                                size="lg"
                                variant="solid"
                                component="a"
                                href="https://aquarium.org.ru/auth"
                                sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                            >
                                Позвонить сейчас
                            </Button>
                        </FadeIn>
                    </Grid>
                    <Grid xs={12} md={6}>
                        <FadeIn delay={0.15} y={40}>
                            <CallDemo />
                        </FadeIn>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
